import React from "react";
import { BrowserRouter } from "react-router-dom";

const Talents = () => {
  return <BrowserRouter>Talents</BrowserRouter>;
};

export default Talents;
